module.exports = __webpack_public_path__ + "static/0024-b785a6b395283e96e2397dc69ece752b.png";